import { DEFAULT_SHADOW_CONFIG } from '@fluentui/merge-styles';
import * as React from 'react';
export var noop = function () {
  return false;
};
export var noopShadow = function () {
  return DEFAULT_SHADOW_CONFIG;
};
export var noopRootStylesheets = function () {
  return new Map();
};
export var noopUndefined = function () {
  return undefined;
};
export var getNewContext = function () {
  return {
    stylesheets: new Map(),
    useAdoptedStylesheetEx: noop,
    useAdoptedStylesheet: noop,
    useShadowConfig: noopShadow,
    useMergeStylesShadowRootContext: noopUndefined,
    useHasMergeStylesShadowRootContext: noop,
    useMergeStylesRootStylesheets: noopRootStylesheets,
    useWindow: noopUndefined,
    useStyled: noopUndefined
  };
};
export var MergeStylesDefaultContext = React.createContext(getNewContext());